@if (profileUser()) {
  <div class="d-flex flex-grow-1 profile-layout position-relative">
    <slotcom-banner
      [urlBanner]="urlBanner"
      class="col-auto">
      <slotcom-profile-header
        [profileUser]="profileUser()!"
        [currentUser]="currentUser"
        [isSelf]="isSelf()"></slotcom-profile-header>
    </slotcom-banner>
    <div class="user-profile">
      <slotcom-profile-tabs
        class="w-100"
        [user]="profileUser()!"
        [isSelf]="isSelf()"
        (tabChanged)="setSelectedTab($event)"></slotcom-profile-tabs>
    </div>
    @if (!isSelf()) {
      <slotcom-navigation-button
        class="close-button"
        type="close"
        topPosition="-2"
        rightPosition="0.5"
        (click)="closeModal()">
      </slotcom-navigation-button>
    }
  </div>
}
